import React from 'react';

import { FmlLifeCycleContext } from '../contexts/FmlLifeCycleContext';

// TODO(FW-2959): types

export const withFmlLifeCycle = (WrappedComponent: React.ComponentType<any>) => {
  return class FmlLifeCycle extends React.Component<any, any> {
    context!: React.ContextType<typeof FmlLifeCycleContext>;
    componentRef = React.createRef<any>();

    constructor(props: any) {
      super(props);
    }

    componentDidMount() {
      const element = this.componentRef.current;
      this.context.onFmlViewWillEnter(() => {
        if (element && element.fmlViewWillEnter) {
          element.fmlViewWillEnter();
        }
      });

      this.context.onFmlViewDidEnter(() => {
        if (element && element.fmlViewDidEnter) {
          element.fmlViewDidEnter();
        }
      });

      this.context.onFmlViewWillLeave(() => {
        if (element && element.fmlViewWillLeave) {
          element.fmlViewWillLeave();
        }
      });

      this.context.onFmlViewDidLeave(() => {
        if (element && element.fmlViewDidLeave) {
          element.fmlViewDidLeave();
        }
      });
    }

    render() {
      return (
        <FmlLifeCycleContext.Consumer>
          {(context) => {
            this.context = context;
            return <WrappedComponent ref={this.componentRef} {...this.props} />;
          }}
        </FmlLifeCycleContext.Consumer>
      );
    }
  };
};
